var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCanvas = function SvgCanvas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M7 0a.5.5 0 0 1 .473.337L8.046 2H13a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1.85l1.323 3.837a.5.5 0 1 1-.946.326L10.092 11H7.5v3a.5.5 0 0 1-1 0v-3H3.908l-1.435 4.163a.5.5 0 1 1-.946-.326L2.85 11H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4.954L6.527.337A.5.5 0 0 1 7 0M1 3v7h12V3z"
  })));
};
export default SvgCanvas;